module.exports = __webpack_public_path__ + "img/certification15.afc62a37.png";